<template>
  <div class="home container">
    <!-- <temp-hours /> -->
    <!-- <covid></covid> -->
    <!-- <banner></banner> -->
    <about />
    <hours />
    <location />
    <store-menu />
  </div>
</template>

<script>
// @ is an alias to /src
// import Banner from "@/components/Banner/Banner.vue";
// import Covid from "@/components/Covid/Covid.vue";
import About from "@/components/About/About.vue";
// import TempHours from "@/components/Hours/TempHours.vue";
import Hours from "@/components/Hours/Hours.vue";
import StoreMenu from "@/components/StoreMenu/StoreMenu.vue";
import Location from "@/components/Location/Location.vue";

export default {
  name: "Home",
  components: { About, Hours, StoreMenu, Location },
  watch: {
    $route() {
      let path = this.$router.currentRoute.hash;
      if (path) {
        path = path.replace("#", "");
      }
      this.scrollToPos(path);
    }
  },
  mounted() {
    let path = this.$router.currentRoute.hash;
    if (path) {
      path = path.replace("#", "");
    }
    this.scrollToPos(path);
  },
  methods: {
    scrollToPos(path) {
      let topPos = 0;
      let topOffset = window.innerWidth > 844 ? 120 : 180;
      if (path) {
        const element = document.getElementsByClassName(path + "-container")[0];
        topPos = element.offsetTop - topOffset;
      }

      window.scroll({
        left: 0,
        top: topPos,
        behavior: "smooth"
      });
    }
  }
};
</script>
<style lang="scss">
.home {
  z-index: 0;
  h3 {
  }
}
</style>
